import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_ENDPOINTS } from "Constants/endpoints";
import { LeadDashboardsResponse, LeadRequest, LeadResponse } from "Interfaces/general";

import { lmsUrlQuery } from "./baseQuery";
import { config } from "config";

export const lmsApi = createApi({
    reducerPath: "lmsApi",
    baseQuery: lmsUrlQuery,
    endpoints: (builder) => ({
        getLeadListing: builder.query<LeadDashboardsResponse, {
            page_size: number,
            page:number
        }>({
            query: (params) => ({
                url: API_ENDPOINTS.LEAD_DASHBOARDS,
                method: "GET",
                params,
                headers: {
                  'PARTNER-NAME':config.clientName
                }
            }),
        }),
        createLead: builder.mutation<LeadResponse, LeadRequest>({
            query: (body) => ({
                url: API_ENDPOINTS.CREATE_LEAD,
                method: "POST",
                body,
                headers: {
                  'PARTNER-NAME':config.clientName
                }
            }),
        }),
        updateLead: builder.mutation<LeadResponse, LeadRequest>({
            query: (body) => ({
                url: API_ENDPOINTS.UPDATE_LEAD,
                method: "PATCH",
                body,
                headers: {
                    'PARTNER-NAME':config.clientName
                }
            }),
        }),
    }),
});

export const { useCreateLeadMutation, useUpdateLeadMutation , useLazyGetLeadListingQuery } = lmsApi;